import { render } from "./PricingTable.vue?vue&type=template&id=0d7862d2&scoped=true"
import script from "./PricingTable.vue?vue&type=script&lang=js"
export * from "./PricingTable.vue?vue&type=script&lang=js"

import "./PricingTable.vue?vue&type=style&index=0&id=0d7862d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7862d2"]])

export default __exports__